import { selfInstantiateOnLoad } from "../utils";
import { SubaruModalBase } from "./subaruModalBase";
const doWindow = window;
export function buildAdditionalData(form) {
    const rmiForm = form;
    let comment = rmiForm.Comments.value;
    const optOut = rmiForm.DoNotSellPersonalInfo;
    if (optOut) {
        comment += ", Do Not Sell Personal Info: " + optOut.checked;
    }
    return {
        Comments: comment,
        VehicleYear: rmiForm.VehicleYear.value,
        VehicleMake: rmiForm.VehicleMake.value,
        VehicleModel: rmiForm.VehicleModel.value,
        VehicleTrim: rmiForm.VehicleTrim.value,
    };
}
export default class SubaruRequestMoreInfoModal extends SubaruModalBase {
    constructor() {
        super("RequestMoreInfoModal", "rmi-open");
        this._openModal = (e) => {
            const trigger = e.currentTarget;
            this._modalTriggerButton = trigger;
            this._form.VehicleYear.value = trigger.getAttribute("data-vehicle-year");
            this._form.VehicleMake.value = trigger.getAttribute("data-vehicle-make");
            this._form.VehicleModel.value = trigger.getAttribute("data-vehicle-model");
            this._form.VehicleTrim.value = trigger.getAttribute("data-vehicle-trim");
            this._showModal();
        };
        if (!this._modal)
            return;
        this._form = this._modal.querySelector("form");
        this.addEventListeners();
        this.initializeLeadData();
    }
    addEventListeners() {
        const openButtons = document.querySelectorAll(".rti-contact-button");
        openButtons.forEach((btn) => btn.addEventListener("click", this._openModal));
    }
    initializeLeadData() {
        const submitOptions = {
            leadSource: parseInt(this._form.LeadSource.value),
            leadType: parseInt(this._form.LeadType.value),
            additionalData: this.getAdditionalData,
        };
        doWindow.DealeronLead.addSubmissionMethod("requestMoreInfoSubmit", submitOptions);
        doWindow.DealeronLead.initialize("#requestMoreInfo", "requestMoreInfoSubmit");
        this._form.FirstName.addEventListener("blur", () => {
            doWindow.DealeronLead.begin();
        }, { once: true });
    }
    getAdditionalData(form) {
        return buildAdditionalData(form);
    }
    trapFocus(e) {
        const closeButtons = this._modal.querySelectorAll("[data-dismiss='modal']");
        const first = closeButtons[0];
        const last = closeButtons[1];
        if (document.activeElement === last && !e.shiftKey) {
            e.preventDefault();
            first.focus();
        }
        else if (document.activeElement === first && e.shiftKey) {
            e.preventDefault();
            last.focus();
        }
    }
}
selfInstantiateOnLoad(SubaruRequestMoreInfoModal);
